import update from 'immutability-helper';
import SendForSignatureStateEnum from './SendForSignatureToolbarConstants';

const initialState = {
  isToolBarNotificationHidden: true,
  message: null,
  notificationType: null,
  prevStep: null,
  step: SendForSignatureStateEnum.REQUEST_CONFIRM,
};

const isValid = (state, action) => {
  const validSteps = Object.keys(SendForSignatureStateEnum).map(
    key => SendForSignatureStateEnum[key],
  );
  const step = action.type;
  const prevStep = action.prevStep || state.step;

  if (validSteps.indexOf(step) < 0 || (prevStep && validSteps.indexOf(prevStep) < 0)) {
    return false;
  }

  return true;
};

const SendForSignatureToolbarHandler = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  }

  switch (action.type) {
    case SendForSignatureStateEnum.HIDE_TOOLBAR_NOTIFICATION:
      return update(state, {
        isToolBarNotificationHidden: { $set: true },
        message: { $set: null },
        notificationType: { $set: null },
      });
    case SendForSignatureStateEnum.SET_ERROR:
    case SendForSignatureStateEnum.SET_SUCCESS:
    case SendForSignatureStateEnum.SET_WARNING:
      return update(state, {
        isToolBarNotificationHidden: { $set: action.isToolBarNotificationHidden },
        message: { $set: action.message },
        notificationType: { $set: action.notificationType },
      });
    case SendForSignatureStateEnum.ADD_FIELDS:
    case SendForSignatureStateEnum.ADD_MESSAGE:
    case SendForSignatureStateEnum.ADD_RECIPIENTS:
    case SendForSignatureStateEnum.REQUEST_CONFIRM:
    case SendForSignatureStateEnum.REQUEST_CANCEL:
    case SendForSignatureStateEnum.REQUEST_PENDING:
    case SendForSignatureStateEnum.REQUEST_PENDING_CANCEL:
    case SendForSignatureStateEnum.REQUEST_SENT:
    case SendForSignatureStateEnum.UPDATE_FIELDS:
    case SendForSignatureStateEnum.UPDATE_RECIPIENTS:
    case SendForSignatureStateEnum.SEND_FOR_SIGNATURE_SIGNATURE_TABS_SHOW:
    case SendForSignatureStateEnum.SEND_FOR_SIGNATURE_SHOW_RECIPIENT_WAITING:
    case SendForSignatureStateEnum.SEND_FOR_SIGNATURE_SHOW_SENDER_SIGNING:
    case SendForSignatureStateEnum.SEND_FOR_SIGNATURE_SHOW_SIGNATURE_STATE:
    case SendForSignatureStateEnum.SEND_FOR_SIGNATURE_SENDER_DONE_SIGNING: {
      if (!isValid(state, action)) {
        return state;
      }
      const step = action.type;
      const prevStep = action.prevStep || state.step;

      if (step === SendForSignatureStateEnum.REQUEST_PENDING_CANCEL) {
        return update(state, {
          step: { $set: initialState.step },
          prevStep: { $set: initialState.prevStep },
          isToolBarNotificationHidden: { $set: false },
        });
      }

      return update(state, {
        step: { $set: step },
        prevStep: { $set: prevStep },
        isToolBarNotificationHidden: { $set: false },
      });
    }
    default:
      return state;
  }
};

export default SendForSignatureToolbarHandler;



// WEBPACK FOOTER //
// ./src-react/SendForSignatureToolbar/SendForSignatureToolbarReducer.jsx